export enum STATUS_CODES {
  NEW = 1800,
  DISABLED = 1900,
  STATUS_LABEL_WITH_PLACE_HOLDER = 3100,
  ACTIVE = 2001
}

export default STATUS_CODES;
